export default __webpack_public_path__ + "static/media/project7.85c4adb6.png";